
@if (message !== undefined) {
  <div class="messageBox" (click)="close()" (keydown)="close()">
    <auro-alert type={{message.type}}>
       <p [innerHTML]="sanitizedText"></p>
    </auro-alert>
  </div>
}